import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";

const PaymentsTypes = () => {
  const [item, setItem] = useState({ kindOfStand: "", another: "another" });

  const { kindOfStand } = item;

  const handleChange = (e) => {
    e.persist();

    setItem((prevState) => ({
      ...prevState,
      kindOfStand: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`${kindOfStand}`);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Form.Group controlId="kindOfStand">
        {/* <Form.Check
          value="Stripe"
          type="radio"
          aria-label="radio 1"
          label="Stripe"
          onChange={handleChange}
          checked={kindOfStand === "Stripe"}
        />
        <Form.Check
          value="PayPal"
          type="radio"
          aria-label="radio 2"
          label="PayPal"
          onChange={handleChange}
          checked={kindOfStand === "PayPal"}
        /> */}
        <Form.Check
          value="Credit/Debit Card"
          type="radio"
          aria-label="radio 3"
          label="Credit/Debit Card"
          onChange={handleChange}
          // checked={kindOfStand === "Credit/Debit Card"}
          checked={true}
        />
      </Form.Group>
    </form>
  );
};

export default PaymentsTypes;
